/**
 * Bolsas: scroll até bloco do modelo via hash (#modelo-<handle>).
 * Se o bloco não existir na página, vai para /collections/<handle>.
 * Compensa header sticky (scroll-margin-top no CSS).
 */
(function () {
  const HASH_PREFIX = '#modelo-';
  const MODELOS_ANCHOR_ID = 'gm-bolsas-modelos';

  function modeloIdFromHash(hash) {
    if (!hash || hash.indexOf(HASH_PREFIX) !== 0) return '';
    return hash.slice(1);
  }

  function handleFromModeloId(id) {
    if (!id || id.indexOf('modelo-') !== 0) return '';
    return id.slice('modelo-'.length);
  }

  function resolveTarget(hash) {
    if (hash === '#' + MODELOS_ANCHOR_ID) {
      return document.getElementById(MODELOS_ANCHOR_ID);
    }
    const id = modeloIdFromHash(hash);
    if (!id) return null;

    let el = document.getElementById(id);
    if (el) return el;

    // Fefa: URL/coleção `bolsa-fefa-camurca` vs metaobject `bolsa-fefa`
    if (id === 'modelo-bolsa-fefa-camurca') {
      el = document.getElementById('modelo-bolsa-fefa');
      if (el) return el;
    } else if (id === 'modelo-bolsa-fefa') {
      el = document.getElementById('modelo-bolsa-fefa-camurca');
      if (el) return el;
    }

    return null;
  }

  function collectionUrlFromHash(hash) {
    const handle = handleFromModeloId(modeloIdFromHash(hash));
    if (!handle) return '';
    return '/collections/' + encodeURIComponent(handle);
  }

  function scrollBehavior(preferred) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return 'auto';
    }
    return preferred || 'smooth';
  }

  function closeAppDrawer() {
    if (window.GmDrawer && typeof window.GmDrawer.close === 'function') {
      window.GmDrawer.close();
      return;
    }
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }
  }

  function goToModeloOrCollection(hash, behavior) {
    const target = resolveTarget(hash);
    if (target) {
      target.scrollIntoView({ behavior: behavior || 'auto', block: 'start' });
      return true;
    }
    const collectionUrl = collectionUrlFromHash(hash);
    if (collectionUrl) {
      window.location.assign(collectionUrl);
      return true;
    }
    return false;
  }

  function onReady() {
    const section = document.querySelector('[data-gm-category="bolsas"]');
    if (!section) return;

    const hash = window.location.hash;
    if (hash) {
      requestAnimationFrame(() => {
        goToModeloOrCollection(hash, 'auto');
      });
    }

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[href*="#modelo-"], a[href*="#gm-bolsas-modelos"]');
        if (!link) return;
        const href = link.getAttribute('href') || '';
        let nextHash = '';
        try {
          const url = new URL(href, window.location.origin);
          if (url.pathname !== window.location.pathname) return;
          nextHash = url.hash;
        } catch (_) {
          return;
        }
        if (!nextHash) return;

        const target = resolveTarget(nextHash);
        if (target) {
          event.preventDefault();
          history.pushState(null, '', nextHash);
          closeAppDrawer();
          target.scrollIntoView({ behavior: scrollBehavior('smooth'), block: 'start' });
          return;
        }

        const collectionUrl = collectionUrlFromHash(nextHash);
        if (!collectionUrl) return;

        event.preventDefault();
        closeAppDrawer();
        window.location.assign(collectionUrl);
      },
      true
    );

    window.addEventListener('hashchange', () => {
      goToModeloOrCollection(window.location.hash, scrollBehavior('smooth'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
